module.exports = __webpack_public_path__ + "static/media/29BDOS1.a80c90a8.jpg";